// Centraliza acesso a variáveis de ambiente VITE_*. Cada consumidor importa
// daqui em vez de ler import.meta.env direto — garante tipagem, fallbacks e
// um único lugar pra alterar contratos com a infra de build/deploy.
//
// Convenção:
//   - URLs vêm SEM trailing slash; quem concatena adiciona "/" explícito.
//   - Strings opcionais: fallback string vazia "" (consumidor decide se mostra).
//   - Strings com default sensato: fallback no próprio default.

const env = import.meta.env;

export const config = {
  api: {
    base: env.VITE_API_BASE ?? '/api',
    key: env.VITE_API_KEY ?? '',
  },

  // Redirect intermediário do tekoblue: registra clique, monta mensagem padrão
  // do operador e redireciona pra wa.me. Multi-tenant futuro troca o trackingSite.
  tekoblue: {
    baseUrl: (env.VITE_TEKOBLUE_GO_URL ?? 'https://go.tekoblue.com').replace(/\/$/, ''),
    trackingSite: env.VITE_TEKOBLUE_TRACKING_SITE ?? 'itaqueri',
  },

  payment: {
    providerName: env.VITE_PAYMENT_PROVIDER_NAME ?? 'AbacatePay',
    providerUrl: env.VITE_PAYMENT_PROVIDER_URL ?? '',
  },

  // Domínio canônico — usado no client para canonical/og:url em navegação
  // client-side (src/utils/seo.ts). O sitemap.xml é gerado estaticamente no
  // build (scripts/build-sitemap.mjs) e o robots.txt é estático (public/).
  siteUrl: (env.VITE_SITE_URL ?? 'https://itaqueri.com').replace(/\/$/, ''),

  umami: {
    websiteId: env.VITE_UMAMI_WEBSITE_ID ?? '',
  },
} as const;
